import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { ICoachRegistryModel, CoachAccrual } from 'app/common/models/coach-registry.model';
import { CoachRegistryService } from 'app/components/coaches/services/coach-registry.service';
import {AlertsService} from 'app/common/components/alerts/services/alerts.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { PaymentTypeAlias } from 'app/common/models/coach-rate.model';
import { IRoutingParams } from 'app/common/models/context.model';
import { ContextService } from 'app/common/services/context.service';
import { CoachesRateCalculateService } from '../../services/coaches-rate-calculate.service';

@Component({
  selector: 'app-coachregistry-element-edit',
  templateUrl: './coachregistry-element-edit.component.html',
  styleUrls: ['./coachregistry-element-edit.component.scss']
})
export class CoachRegistryElementEditComponent implements OnInit {

  @Input() element: CoachAccrual;
  @Input() registry: ICoachRegistryModel;
  @Output() result = new EventEmitter<CoachAccrual>();

  public form: FormGroup;
  public params: any = {};
  public aliasParams: any[] = [];
  public paramDetailsList: any[] = [];
  public titleDetailsList: any[] = [];
  public mainParamDetailsList: any[] = [];
  public selectedAlias: any = {};
  public aliases: any[] = [];
  public coachSalaryCalculators: {
    [ key in PaymentTypeAlias | 'salary' | 'other']: {
      aliasDisplayName: string,
      func: (params: any) => number,
      params: string[]
    }
  } = {
    
    "class": {
      aliasDisplayName:"Ставка за занятие",
      func: this.calcSalaryClass,
      params: ["class"]
    },
    "personInGroup": {
      aliasDisplayName:"Ставка за человека",
      func: this.calcSalaryPersonInGroup ,
      params: ["personInGroupRate", "personCount"]
    },
    "subscription": {
      aliasDisplayName:"За абонемент",
      func: this.calcAboniment ,
      params: ["subscriptions", "personCount"]
    },
    "pctWithMissed":{
      aliasDisplayName: "% от занятия, включая пропуски",
      func: this.calcAboniment ,
      params: ["forUnlimitedRate", "personCount", "total"]
    },
    "pctWithoutMissed":{
      aliasDisplayName: "% от занятия без пропусков",
      func: this.calcAboniment ,
      params: ["forUnlimitedRate", "personCount", "total"]
    },
    "progressiveRate": {
      aliasDisplayName:"Прогрессивная ставка",
      func: this.calcProgressive,
      params: ["personCount", "total", "classesRate", "personsRate"]
    },
    "salary": {
      aliasDisplayName:"Оклад",
      func: this.calcSalary,
      params: ["salary"]
    },
    "other": {
      aliasDisplayName:"Прочее",
      func: this.calcAdditional,
      params: ["other"]
    },
    "withoutRate": {
      aliasDisplayName:"Ставка не найдена",
      func: this.calcAdditional,
      params: ["personCount", "total"]
    }
  };
  isOpenPersonRatePopup = false;
  isOpenClassRatePopup = false;
  private group: any = {};
  private basicParams: any;
  private allParamsInfoEdit: any[] = [];
  private formattedTotal: string;
  private formTotal: string;
  private calcTotal: string;
  private selectAliasSave: string;
  public contextService: ContextService;
  public routingParams: IRoutingParams;

  constructor(
    private coachRegistryService: CoachRegistryService,
    private alertsService: AlertsService,
    private readonly injector: Injector,
    private coachesRateCalculate: CoachesRateCalculateService
  ) {
    this.contextService = injector.get(ContextService);
    this.contextService.routingParams.subscribe(params => {
      this.routingParams = params;
    });
  }

  async ngOnInit(): Promise<any> {
    this.basicParams = this.coachesRateCalculate.basicParams;
    this.selectedAlias = this.element.paymentTypeAlias ?? PaymentTypeAlias.class;
    this.aliases = Object.keys(this.coachesRateCalculate.coachSalaryCalculators).filter(
      key => key !== 'subscription' && key !=='withoutRate'
    ); //Больше не используется
    this.params = JSON.parse(this.element.params);
    this.aliasParams.push({
      name: "title",
      displayName: "Комментарий",
      type: "text",
      formControlName: "title",
      value: this.element.title
    })
    
    for(let p of this.coachesRateCalculate.coachSalaryCalculators[this.selectedAlias].params) {
      if (p == 'personCount'){
        this.aliasParams.push({
          name: p,
          displayName: this.basicParams[p].paramDisplayName,
          type: this.basicParams[p].paramType,
          formControlName: p,
          value: !isNaN(this.params[p]) ? this.params[p]: "0"
        });
        continue; 
      }
      if (p == 'classesRate'){
        this.aliasParams.push({
          name: p,
          displayName: this.basicParams[p].paramDisplayName,
          type: this.basicParams[p].paramType,
          formControlName: p,
          value: this.setClassesRate(this.params)
        });
        continue; 
      }
      if (p == 'personsRate'){
         
        this.aliasParams.push({
          name: p,
          displayName: this.basicParams[p].paramDisplayName,
          type: this.basicParams[p].paramType,
          formControlName: p,
          value: this.setPersonsRate(this.params)
        });
        continue; 
      }
      if (p == 'total'){
        this.aliasParams.push({
          name: p,
          displayName: this.basicParams[p].paramDisplayName,
          detailsName: "Рассчитанная сумма", 
          type: this.basicParams[p].paramType,
          formControlName: p,
          value: !isNaN(this.element.total)
          ? (Number.isInteger(Number(this.element.total)) 
              ? Number(this.element.total).toString() 
              : Number(this.element.total).toFixed(2))
          : "0.00"
        });
        continue; 
      }
      this.aliasParams.push({
        name: p,
        displayName: this.basicParams[p].paramDisplayName,
        type: this.basicParams[p].paramType,
        formControlName: p,
        value: !isNaN(this.params[p])
        ? (Number.isInteger(Number(this.params[p])) 
            ? Number(this.params[p]).toString() 
            : Number(this.params[p]).toFixed(2))
        : "0.00"
      });

    }
    if(this.aliasParams.length) {
      this.group[this.aliasParams[0].name] = new FormControl(this.aliasParams[0].value.toString().replace('&lt;', '<').replace('&gt;', '>'), Validators.required);
        for(let i = 1; i < this.aliasParams.length; i++)
        {
          this.group[this.aliasParams[i].name] = new FormControl(this.aliasParams[i].value.toString(), Validators.required);
        }
      this.group['status'] = new FormControl(this.element.status, Validators.required);
      this.form = new FormGroup(this.group);
    }
    let total = parseFloat(this.element.total);
    this.formattedTotal = !isNaN(total) ? total.toFixed(2) : "0.00";
    this.calcTotal = (+this.coachesRateCalculate.coachSalaryCalculators[this.selectedAlias].edit(this.params) || 0).toFixed(2);
    this.allParamsInfoEdit = this.allParamsInfo();
    this.formTotal = this.formattedTotal; 
    this.selectAliasSave = this.selectedAlias; 
    this.paramDetailsList = this.paramDetails(this.selectedAlias);
    this.mainParamDetailsList = this.mainParamDetails(this.selectedAlias);
    this.titleDetailsList = this.titleDetails(); 
    this.setDetails(this.selectedAlias); 
  }
  
  public titleDetails(): any{
    let res = [];
    for (let p of this.coachesRateCalculate.coachSalaryCalculators[this.selectedAlias].params) {
      if (p === "personCount") {  
          res.push({
              name: this.basicParams[p].paramDisplayName,
              value: this.params[p]
          });
      }
  }
    return res;
  }

  public truncatedRate(rate: string): string {
    const maxLength = 17; 
    return rate.length > maxLength 
      ? `${rate.substring(0, maxLength)}[...]` 
      : rate;
  }

  public changeAlias(alias){
    this.selectAliasSave = alias;
    this.aliasParams = []
    this.aliasParams.push({
      name: "title",
      displayName: "Комментарий",
      type: "text",
      formControlName: "title",
      value: this.element.title
    })
    for (let p of this.coachesRateCalculate.coachSalaryCalculators[alias].params) {
      if (p == 'classesRate'){
        this.aliasParams.push({
          name: p,
          displayName: this.basicParams[p].paramDisplayName,
          type: this.basicParams[p].paramType,
          formControlName: p,
          value: this.setClassesRate(this.params)
        });
        continue; 
      }
      if (p == 'personsRate'){
        this.aliasParams.push({
          name: p,
          displayName: this.basicParams[p].paramDisplayName,
          type: this.basicParams[p].paramType,
          formControlName: p,
          value: this.setPersonsRate(this.params)
        });
        continue; 
      }
      this.aliasParams.push({
        name: p || "",
        displayName: this.basicParams[p].paramDisplayName || "",
        type: this.basicParams[p].paramType || "text",
        formControlName: p,
        value: !isNaN(this.params[p])
        ? (Number.isInteger(this.params[p]) 
            ? this.params[p].toString() 
            : this.params[p].toFixed(2))
        : "0.00"
      })
    }

    this.group = {};
    if(this.aliasParams.length) {
      this.group[this.aliasParams[0].name] = new FormControl(this.aliasParams[0].value.toString().replace('&lt;', '<').replace('&gt;', '>'), Validators.required)
      for(let i = 1; i < this.aliasParams.length; i++) {
        this.group[this.aliasParams[i].name] = new FormControl(this.aliasParams[i].value.toString(), Validators.required)
      }
      this.group['status'] = new FormControl(this.element.status, Validators.required);
      this.form = new FormGroup(this.group);
    }
    this.allParamsInfoEdit = this.allParamsInfo();
  }

  public async mainSave(){
    await this.coachRegistryService.saveAccrual(this.element).then(async (e) => {
      if (e) {
        this.element.isEnableMode = false;
        this.result.emit(this.element);
        this.alertsService.alert.next({
          type: 'success',
          message: 'Транзакция сохранена',
          header: 'Успех',
          position: 'top',
          timeout: 2000
        });
      } else {
        console.error(e);
      }
    });
  }
  public async openRateConfig(popupType: 'person' | 'class') {
    if (popupType === 'person') {
      this.isOpenPersonRatePopup = true;
    } else {
      this.isOpenClassRatePopup = true;
    }
  }
  public async onRatesSaved(newRate: string, rateType: 'person' | 'class') {
    const foundPersonRate = this.aliasParams.find((p: any) => p.name === 'personsRate');
    const foundClassesRate = this.aliasParams.find((p: any) => p.name === 'classesRate');

    if (rateType === 'person') {
      if (foundPersonRate) {
        foundPersonRate.value = newRate; 
      }
      this.isOpenPersonRatePopup = false;
      }
      
    else {
      if (foundClassesRate) {
        
        foundClassesRate.value = newRate;
      }
      this.isOpenClassRatePopup = false;
    }
    let formTotalNew = '0';
    
    if (foundClassesRate.value || foundPersonRate.value) {
      this.setUniversalRateByProgressive(foundClassesRate.value, foundPersonRate.value)
      this.element.params = JSON.stringify(this.params);
      if (this.coachesRateCalculate.coachSalaryCalculators[this.selectedAlias].params.includes('total')){
        formTotalNew = isNaN(this.form.get('total').value) ? '0' : Number.parseFloat(this.form.get('total').value).toFixed(2);
      }
      let calcTotalForm = this.coachesRateCalculate.coachSalaryCalculators[this.selectedAlias].edit(this.params).toFixed(2);
      await this.calcDetails(calcTotalForm, formTotalNew);
      await this.mainSave();
      await this.updateDetails();
    }
    else{
      console.error("Ошибка при сохранении");
    }
  }
  public async save(): Promise<any> {
    this.selectedAlias = this.selectAliasSave; 
    let formTotalNew = '0'; 
    if (this.form.valid) {
      for (let p of this.coachesRateCalculate.coachSalaryCalculators[this.selectedAlias].params) {
        if (p == 'personsRate' || p == 'classesRate'){
          continue; 
        }
        if (p=='total'){
          formTotalNew = isNaN(this.form.get(p).value) ? '0' : Number.parseFloat(this.form.get(p).value).toFixed(2);
        }
        this.params[p] = isNaN(this.form.get(p).value) ? 0 : Number.parseFloat(this.form.get(p).value);
        
      }
      let calcTotalForm = this.coachesRateCalculate.coachSalaryCalculators[this.selectedAlias].edit(this.params).toFixed(2);
      await this.calcDetails(calcTotalForm, formTotalNew);

      
      this.element.paymentTypeAlias = this.selectedAlias;
      this.element.params = JSON.stringify(this.params);
      this.element.title = this.form.get('title').value;
      this.element.status = this.form.get('status').value;

      await this.mainSave();
      await this.updateDetails();
      this.setDetails(this.element.paymentTypeAlias); 
    }
    else
      console.log('Form is invalid!')
    
  }
  private async calcDetails(calcTotalForm: any, formTotalNew: any){
    if (parseFloat(formTotalNew) === 0) {
      this.element.total = calcTotalForm;
    }else
    if (formTotalNew!=this.formTotal){
      this.element.total = formTotalNew; 
    } else if (this.calcTotal!=formTotalNew) {
      this.element.total = formTotalNew; 
    }
    else{
      this.element.total = calcTotalForm;
    }
    this.formTotal = this.element.total; 
    this.calcTotal = calcTotalForm; 
    let total = parseFloat(this.element.total);
    this.formattedTotal = !isNaN(total) ? total.toFixed(2) : "0.00";
    if (this.form.get('total')) {
      this.form.get('total').setValue(this.formattedTotal);
    }
  }
  private async updateDetails(){
    this.allParamsInfoEdit = this.allParamsInfo();
    this.paramDetailsList = this.paramDetails(this.selectedAlias);
    this.mainParamDetailsList = this.mainParamDetails(this.selectedAlias);
    this.titleDetailsList = this.titleDetails(); 
  }
  public mainParamDetails(alias: any): any {
    switch (alias) {
        case "pctWithMissed":
        case "pctWithoutMissed":
            return `: ${this.params["subscriptionPercentRate"]}%`;
        case "personInGroup":
            return `: ${this.params["personInGroupRate"]}`;
        case "class":
            return `: ${this.params[alias]}`;
        default:
            return "";
    }
  }
  public paramDetails(alias: string): any {
    if (!alias) return "";

    const skipParamsMap = {
        pctWithMissed: "subscriptionPercentRate",
        pctWithoutMissed: "subscriptionPercentRate",
        personInGroup: "personInGroupRate",
        class: "class"
    };

    if (!skipParamsMap.hasOwnProperty(alias)) return "";

    const skipParam = skipParamsMap[alias];
    const result = [];

    for (const param of this.coachesRateCalculate.coachSalaryCalculators[this.selectedAlias].params) {
        if (!["personCount", "salary", "total", skipParam].includes(param)) {
            result.push({
                name: this.basicParams[param].paramDisplayName,
                value: this.params[param]
            });
        }
    }

    return result.length > 0 ? result : "";
  }
  
  public onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 
      'Delete', 'Home', 'End'
    ];
  
    if (allowedKeys.includes(event.key)) {
      return; 
    }
  
    if (event.key === '.' || event.key === ',' || isNaN(Number(event.key))) {
      event.preventDefault();
    }
  }
  public setTwoNumberDecimal(evt: Event) {
    const input = evt.target as HTMLInputElement;
    const regex = new RegExp(/^\d*(\.\d{0,2})?$/, 'g');

    let newVal = input.value;
    if(!regex.test(newVal)){
      let correctVal = {}
      correctVal[input.name] = input.value.slice(0, -1);

      this.form.patchValue(correctVal);
    }
  }

  public openPageClass(el: { classId: string, date: number }) {
    if (!el.classId) return;
    const date = new Date(el.date);
    const d = `0${date.getUTCDate()}`.slice(-2);
    const m = `0${date.getUTCMonth()}`.slice(-2);
    const url = `${this.routingParams.cityId}/${this.routingParams.clubNetId}/${this.routingParams.clubId}/clubschedule/${d}.${m}.${date.getUTCFullYear()}/${el.classId}`;
    window.open(url);
  }
  public allParamsInfo(): any {
    let res = [];
    let paramsItem = [...this.coachesRateCalculate.coachSalaryCalculators[this.selectedAlias].params];
    if (this.selectedAlias != "salary" && this.selectedAlias != "other" ) {
      paramsItem.push("duration");
    }
    if (this.selectedAlias == "progressiveRate" && this.params.classesCount){
      res.push({
        name: "Число занятий",
        value: this.params.classesCount
      })
    }
    for(let p of paramsItem) {
      if (p == 'personsRate' || p == 'classesRate'){
        continue; 
      }
      if (p=="total")
      {
        res.push({
          name: this.basicParams[p].paramDisplayName ,
          value: this.formattedTotal
        })
      } else{
        res.push({
          name: this.basicParams[p].paramDisplayName ,
          value: !isNaN(this.params[p])
          ? (Number.isInteger(Number(this.params[p])) 
              ? Number(this.params[p]).toString() 
              : Number(this.params[p]).toFixed(2))
          : "0.00"
        })
      }

    }
    return res;
  }
  private setUniversalRateByProgressive(classesRate: string, personsRate: string){
    this.params["universalRate"] = `${classesRate}/${personsRate}`
  }
  private setClassesRate(params: any): string{
    let universalRate = params['universalRate'];
    if (universalRate){
      const [classesRateStr, personsRateStr] = universalRate.split('/');
      return classesRateStr;
    } else{
      return "0=0";
    }

  }
  private setPersonsRate(params: any): string{
    let universalRate = params['universalRate'];
    if (universalRate){
      const [classesRateStr, personsRateStr] = universalRate.split('/');
      return personsRateStr;
    }
    else{
      return "0=0";
    }
  }
  private calcSalaryClass(params: any): number{
    return params['class'] || 0;
  }

  private calcSalaryPersonInGroup(params: any): number{
    return (params['personInGroupRate'] || 0) * (params['personCount'] || 0);
  }

  private calcAboniment(params: any): number{
    return (params['subscriptions']);
  }

  private calcSalary(params:any): number{
    return params['salary'] || 0;
  }

  private calcAdditional(params: any): number{
    return params['other'] || 0;
  }
  public calcProgressive(params: any): number {
    return this.coachesRateCalculate.calcProgressive(params); 
  }
  public getTooltipInfoForClass(key: string): string {
    return this.coachesRateCalculate.tooltipInfo[key]
  }
  private setDetails(alias: any){
        switch (alias) {
        case "progressiveRate":
            this.params.details = [
              "Сумма за занимающихся: " + this.coachesRateCalculate.calcProgressive(this.params, "person"),
              "Сумма за занятие: " + this.coachesRateCalculate.calcProgressive(this.params, "class")
            ]
            return `: ${this.params[alias]}`;
        default:
            return "";
    }
  }
}
